import React, { useState, useEffect, useCallback } from "react";

import orderServiceInstance from "../../../APIs/order";
import {  Drawer, Form,  message,  } from "antd";
import userServiceInstance from "../../../APIs/users";

import logisticsServiceInstance, {
  
} from "../../../APIs/logistics";

import addressServiceInstance from "../../../APIs/address";
import OrdersTable from "./OrdersTable/OrdersTable";
import OrderHistorys from "./OrderHistory/OrderHistory";
import { useNotification } from "../../Toast/Notification";
import OrderHeader from "./OrderHeader/OrderHeader";
import OrderTab from "./OrderTab/OrderTab";
import OrderDetails from "./OrderDetails/OrderDetails";
import OrderStatus from "./OrderStatus/OrderStatus";
import HeaderTable from "../HeaderTable/HeaderTable";
import { OrderHistory } from "../../../@types/order-history";
import orderHistoryServiceInstance from "../../../APIs/orderHistory";



interface ProductOrdered {
  product_sku?: string;
  name: string;
  price: number;
  quantity: number;
  product_id: number;
  order_type: string;
  product_image?: string;
  height?: number;
  width?: number;
  length?: number;
  weight?: number;
  productDescription?: string;
  quote_status?: string;
}

interface Order {
  id: number;
  status: string;
  address_id: string;
  vat: number;
  grand_total: number;
  total_price: number;
  date_ordered: string | null;
  requested_ship_date: string;
  reference_number: string;
  user_id: number;
  products: ProductOrdered[];
  receipt_url: string | null;
  sku?: string;
  quote_status: string;
  quote_id: string;
  latest_status: string;
}

export interface ParcelItem {
  key: React.Key;
  parcelNo: number;
  items: number;
  height: number;
  width: number;
  length: number;
  weight: number;
}

const Orders: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [editingOrder, setEditingOrder] = useState<Order | null>(null);
  const [isDrawerVisible, setIsDrawerVisible] = useState<boolean>(false);
  const [form] = Form.useForm();

  const [orderReference, setOrderReference] = useState<string>("");

  const [userInfo, setUserInfo] = useState<any>(null);
  const [values, setValues] = useState<ParcelItem[]>([]);
  const [saveHistory, setSaveHistory] = useState<OrderHistory[]>([]);
  const [recentOrderStatus, setRecentOrderStatus] = useState<any>(null);
  const [userAddress, setUserAddress] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<number>(1);
  const [selectedRole, setSelectedRole] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 7;
  const [pageNumbers, setPageNumbers] = useState<number[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<Order[]>([]);

  const { notify } = useNotification();
  const handleTabClick = (tabIndex: number) => {
    setActiveTab(tabIndex);
  };

  useEffect(() => {
    if (userInfo && userInfo?.id) {
      getUserAddress(userInfo.id);
    }
  }, [userInfo, userInfo?.id]);

  useEffect(() => {
    fetchOrders();
    if (orderReference) {
      fetchRecentOrderStatus(orderReference);
      fetchSaveHistory(orderReference);
    }
  }, [orderReference]);

  const handleViewLabelsClick = (parcel: ParcelItem) => {
  
  
  };

  const fetchOrders = async () => {
    try {
      const result = await orderServiceInstance.getAllOrders();
      if (result.data) {
        setOrders(result.data || []);
        setFilteredProducts(result.data || []);

      }
    } catch (err) {
      console.error("Failed to fetch orders:", err);
    }
    setLoading(false);
  };

  const fetchSaveHistory = async (waybill: string) => {
    try {
      const result = await orderHistoryServiceInstance.getOrderHistoryByUserId(
        waybill
      );

      if (result.data) {
        setSaveHistory(result.data || []);
      }
    } catch (err) {
      console.error("Failed to fetch save history:", err);
      message.error("Failed to fetch save history");
    }
  };

  const fetchRecentOrderStatus = async (waybill: string) => {
    try {
      const result = await orderHistoryServiceInstance.getLatestOrderHistory(
        waybill
      );

      if (result.data) {
        setRecentOrderStatus(result.data);

      } else {
        console.error(result.error);
      }
    } catch (err) {
      console.error("Failed to fetch save history:", err);
      message.error("Failed to fetch save history");
    }
  };

  const getUserAddress = async (userId: number) => {
    try {
      const response = await addressServiceInstance.getAddressByUserId(userId);
      const data = response.data;
      setUserAddress(data || null);

    } catch (err) {
      console.error("Failed to fetch user address:", err);
      setUserAddress(null);
    }
  };

  const handleDrawerClose = () => {
    setIsDrawerVisible(false);
    setSaveHistory([]);
    setRecentOrderStatus("");
    form.resetFields();
  };

  const handleEditClick = async (order: Order) => {
    setEditingOrder(order);
    setOrderReference(order.reference_number);
    form.setFieldsValue({
      status: order.status,
    });

    try {
      const userResult = await userServiceInstance.getUserById(order.user_id);
      if (userResult.data) {
        setUserInfo(userResult.data);
      } else {
        message.error("Failed to fetch user info");
      }
    } catch (error) {
      console.error("Failed to fetch user info:", error);
      message.error("Failed to fetch user info");
    }

    setIsDrawerVisible(true);
  };



  const createLogistics = async () => {
    setLoading(true);

    if (editingOrder && userInfo && userAddress) {
      try {
        const response = await logisticsServiceInstance.acceptQuote(
          editingOrder?.quote_id
        );

        if (response.data) {


          notify("Quote successfully accepted", "success");
        } else {
          console.error(
            "An error occured while creating quote",
            response.error
          );
          message.error("An error occured while creating quote");
        }
      } catch {
        console.log("An error occured while creating quote, please try again ");
      } finally {
        setLoading(false);
      }
    }
  };




  const filterProductsFromSearch = useCallback((currentProducts: Order[]) => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
  
    const tempProducts = currentProducts.filter((product) => {
      const productProperties = Object.values(product).map((value) =>
        String(value).toLowerCase()
      );
      return (
        (selectedRole === "all" || product.quote_status === selectedRole) &&
        productProperties.some((property) =>
          property.includes(lowerCaseSearchTerm)
        )
      );
    });
  
    setFilteredProducts(tempProducts);
    setCurrentPage(1);
  }, [searchTerm, selectedRole, setFilteredProducts, setCurrentPage]);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterProductsFromSearch(orders);
    } else {
      setFilteredProducts(orders);
    }
  }, [searchTerm, orders, filterProductsFromSearch]);

  useEffect(() => {
    filterProductsFromSearch(orders);
  }, [searchTerm, selectedRole, orders, filterProductsFromSearch]);

  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const generatePageNumbers = useCallback(() => {
    const numbers = [];
    for (let i = 1; i <= totalPages; i++) {
      numbers.push(i);
    }
    setPageNumbers(numbers);
  }, [totalPages, setPageNumbers]);

  useEffect(() => {
    generatePageNumbers();
  }, [generatePageNumbers, totalPages]);

  const handleSearchTermChange = (e: any) => {
    setSearchTerm(e.target.value);
  };

  const handleRoleChange = (event: any) => {
    setSelectedRole(event.target.value);
  };

  return (
    <div className="p-6">
      <div className="text-center py-2 mb-3 ">
        <p
          className=" box-border font-semibold text-[rgb(0,34,56)] block  text-[35px]  text-left h-[38px]
       leading-[38.4px] mb-1">
          Orders
        </p>
      </div>

      <div className="bg-white p-4 rounded-md w-5/4 mx-auto">
 
        <HeaderTable
          subtitle="Manage Orders"
          // buttonText="Add New P"
          inputPlaceholder="Search Order"
          selectPlaceholder="Filter By Quote Status"
          loading={false}
          searchTerm={searchTerm}
          selectedValue={selectedRole}
          // onButtonClick={handleAddProductClick}
          onSearchChange={handleSearchTermChange}
          onSelectChange={handleRoleChange}
          selectOptions={[
            { value: "accepted", label: "Accepted" },
            { value: "declined", label: "Declined" },
          ]}
        />
        <OrdersTable
          products={filteredProducts}
          loading={loading}
          onEditOrder={handleEditClick}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          pageNumbers={pageNumbers}
          currentProducts={currentProducts}
          //  handleDeleteAcc={handleDeleteAcc}
        />
        <Drawer
          title={
            <OrderHeader userInfo={userInfo} editingOrder={editingOrder} />
          }
          width={750}
          visible={isDrawerVisible}
          onClose={handleDrawerClose}>
          <div className="">
            <OrderTab activeTab={activeTab} handleTabClick={handleTabClick} />
            <div className="bg-white p-4 rounded-md w-full">
              {activeTab === 1 && editingOrder && (
                <OrderDetails editingOrder={editingOrder} />
              )}

              {activeTab === 2 && (
                <OrderStatus
                  editingOrder={editingOrder}
                  loading={loading}
                  values={values}
                  recentOrderStatus={recentOrderStatus}
                  setValues={setValues}
                  handleViewLabelsClick={handleViewLabelsClick}
                  createLogistics={createLogistics}
                 
                />
              )}
              {activeTab === 3 && <OrderHistorys saveHistory={saveHistory} />}
            </div>
          </div>
        </Drawer>
      </div>
    </div>
  );
};

export default Orders;
